import { Flex } from 'antd';
import styled, { css } from 'styled-components';
import { atPaneWidth } from './paneWidth';

export const TimerCardWrapper = styled(Flex)`
  border: 1px solid var(--clr-border-grey-100);
  padding: 10px;
  border-radius: 5px;
  background-color: var(--clr-container-bg);
  transition: background 0.2s linear;
  .card-cta-wrapper {
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
    }
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column-reverse;
    gap: 10px;
    .timer-cta-divider {
      width: 100%;
    }
    .card-actions {
      width: 100%;
      justify-content: center;
      gap: 16px;
    }
    ${atPaneWidth(
      'min-width',
      400,
      css`
        justify-content: space-between;
        flex-direction: row;
        gap: 25px;
        .timer-cta-divider {
          display: none;
        }
        .card-actions {
          width: auto;
          gap: 10px;
        }
      `,
    )}
  }
  &:hover {
    background-color: var(--clr-general-hover);
  }
  .horizontal-dot-icon {
    svg {
      max-width: none;
    }
  }
`;

export const TimerContainer = styled(Flex)`
  gap: 10px;
  padding: 2px 10px 2px 2px;
  background-color: rgba(var(--clr-general-primary-rgb), 0.2);
  border-radius: 30px;
  min-width: 107px;
  align-items: center;

  .ant-btn {
    background-color: var(--clr-general-primary);
    width: 28px;
    height: 28px;
    border-radius: 50px;
    .ant-btn-icon {
      color: var(--clr-white);
      font-size: 18px;
    }
    &:not(:disabled):not(.ant-btn-disabled):hover {
      background-color: var(--clr-general-primary);
    }
  }
`;

export const DetailsContainer = styled(Flex)`
  border: 1px solid var(--clr-border-grey-100);
  padding: 10px;
  border-radius: 5px;
  background-color: var(--clr-container-bg);
  .icon {
    font-size: 21px;
    color: var(--clr-icon-color);
    flex-shrink: 0;
  }
`;

export const TimerHeaderDetail = styled(Flex)`
  background-color: var(--clr-container-bg);
  padding: 15px;
  margin-inline: -15px;
  border-bottom: 1px solid var(--clr-border-grey-100);
  flex-shrink: 0;
`;
